<template>
  <base-template>
    <div class="header-area" id="headerArea">
      <div class="container">
        <!-- # Paste your Header Content from here -->
        <!-- # Header Five Layout -->
        <!-- # Copy the code from here ... -->
        <!-- Header Content -->
        <div class="header-content header-style-five position-relative d-flex align-items-center justify-content-between">
          <!-- Logo Wrapper -->
          <div v-if="appLogo==='light'" class="logo-wrapper"><router-link to="/"><img id="app-logo" :src="logo" alt=""></router-link></div>
          <div v-else class="logo-wrapper"><router-link to="/"><img id="app-logo" src="../../assets/redge-light.png" alt=""></router-link></div>
          <!-- Navbar Toggler -->
          <div class="navbar--toggler" @click="showSideBar" data-bs-toggle="offcanvas" data-bs-target="#affanOffcanvas" aria-controls="affanOffcanvas">
            <!-- <span class="d-block"></span>
            <span class="d-block"></span>
            <span class="d-block"></span> -->
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" class="hamburger">
              <path d="M7.25687 5.89462C8.06884 5.35208 9.02346 5.0625 10 5.0625C11.3095 5.0625 12.5654 5.5827 13.4913 6.50866C14.4173 7.43462 14.9375 8.6905 14.9375 10C14.9375 10.9765 14.6479 11.9312 14.1054 12.7431C13.5628 13.5551 12.7917 14.188 11.8895 14.5617C10.9873 14.9354 9.99452 15.0331 9.03674 14.8426C8.07896 14.6521 7.19918 14.1819 6.50866 13.4913C5.81814 12.8008 5.34789 11.921 5.15737 10.9633C4.96686 10.0055 5.06464 9.01271 5.43835 8.1105C5.81205 7.20829 6.44491 6.43716 7.25687 5.89462ZM8.29857 12.5464C8.80219 12.8829 9.3943 13.0625 10 13.0625C10.8122 13.0625 11.5912 12.7398 12.1655 12.1655C12.7398 11.5912 13.0625 10.8122 13.0625 10C13.0625 9.3943 12.8829 8.80219 12.5464 8.29857C12.2099 7.79494 11.7316 7.40241 11.172 7.17062C10.6124 6.93883 9.99661 6.87818 9.40254 6.99635C8.80847 7.11451 8.26279 7.40619 7.83449 7.83449C7.40619 8.26279 7.11451 8.80847 6.99635 9.40254C6.87818 9.99661 6.93883 10.6124 7.17062 11.172C7.40241 11.7316 7.79494 12.2099 8.29857 12.5464ZM24.7431 14.1054C23.9312 14.6479 22.9765 14.9375 22 14.9375C20.6905 14.9375 19.4346 14.4173 18.5087 13.4913C17.5827 12.5654 17.0625 11.3095 17.0625 10C17.0625 9.02346 17.3521 8.06884 17.8946 7.25687C18.4372 6.44491 19.2083 5.81205 20.1105 5.43835C21.0127 5.06464 22.0055 4.96686 22.9633 5.15737C23.921 5.34789 24.8008 5.81814 25.4913 6.50866C26.1819 7.19918 26.6521 8.07896 26.8426 9.03674C27.0331 9.99452 26.9354 10.9873 26.5617 11.8895C26.1879 12.7917 25.5551 13.5628 24.7431 14.1054ZM23.7014 7.45363C23.1978 7.11712 22.6057 6.9375 22 6.9375C21.1878 6.9375 20.4088 7.26016 19.8345 7.83449C19.2602 8.40882 18.9375 9.18778 18.9375 10C18.9375 10.6057 19.1171 11.1978 19.4536 11.7014C19.7901 12.2051 20.2684 12.5976 20.828 12.8294C21.3876 13.0612 22.0034 13.1218 22.5975 13.0037C23.1915 12.8855 23.7372 12.5938 24.1655 12.1655C24.5938 11.7372 24.8855 11.1915 25.0037 10.5975C25.1218 10.0034 25.0612 9.38763 24.8294 8.82803C24.5976 8.26844 24.2051 7.79014 23.7014 7.45363ZM7.25687 17.8946C8.06884 17.3521 9.02346 17.0625 10 17.0625C11.3095 17.0625 12.5654 17.5827 13.4913 18.5087C14.4173 19.4346 14.9375 20.6905 14.9375 22C14.9375 22.9765 14.6479 23.9312 14.1054 24.7431C13.5628 25.5551 12.7917 26.1879 11.8895 26.5617C10.9873 26.9354 9.99452 27.0331 9.03674 26.8426C8.07896 26.6521 7.19918 26.1819 6.50866 25.4913C5.81814 24.8008 5.34789 23.921 5.15737 22.9633C4.96686 22.0055 5.06464 21.0127 5.43835 20.1105C5.81205 19.2083 6.44491 18.4372 7.25687 17.8946ZM8.29857 24.5464C8.80219 24.8829 9.3943 25.0625 10 25.0625C10.8122 25.0625 11.5912 24.7398 12.1655 24.1655C12.7398 23.5912 13.0625 22.8122 13.0625 22C13.0625 21.3943 12.8829 20.8022 12.5464 20.2986C12.2099 19.7949 11.7316 19.4024 11.172 19.1706C10.6124 18.9388 9.99661 18.8782 9.40254 18.9963C8.80847 19.1145 8.26279 19.4062 7.83449 19.8345C7.40619 20.2628 7.11451 20.8085 6.99635 21.4025C6.87818 21.9966 6.93883 22.6124 7.17062 23.172C7.40241 23.7316 7.79494 24.2099 8.29857 24.5464ZM19.2569 17.8946C20.0688 17.3521 21.0235 17.0625 22 17.0625C23.3095 17.0625 24.5654 17.5827 25.4913 18.5087C26.4173 19.4346 26.9375 20.6905 26.9375 22C26.9375 22.9765 26.6479 23.9312 26.1054 24.7431C25.5628 25.5551 24.7917 26.1879 23.8895 26.5617C22.9873 26.9354 21.9945 27.0331 21.0367 26.8426C20.079 26.6521 19.1992 26.1819 18.5087 25.4913C17.8181 24.8008 17.3479 23.921 17.1574 22.9633C16.9669 22.0055 17.0646 21.0127 17.4383 20.1105C17.8121 19.2083 18.4449 18.4372 19.2569 17.8946ZM20.2986 24.5464C20.8022 24.8829 21.3943 25.0625 22 25.0625C22.8122 25.0625 23.5912 24.7398 24.1655 24.1655C24.7398 23.5912 25.0625 22.8122 25.0625 22C25.0625 21.3943 24.8829 20.8022 24.5464 20.2986C24.2099 19.7949 23.7316 19.4024 23.172 19.1706C22.6124 18.9388 21.9966 18.8782 21.4025 18.9963C20.8085 19.1145 20.2628 19.4062 19.8345 19.8345C19.4062 20.2628 19.1145 20.8085 18.9963 21.4025C18.8782 21.9966 18.9388 22.6124 19.1706 23.172C19.4024 23.7316 19.7949 24.2099 20.2986 24.5464Z" stroke-width="0.125"></path>
            </svg>
          </div>
        </div>
        <!-- # Header Five Layout End -->
      </div>
    </div>
    
    <div :class="`offcanvas offcanvas-start ${sidebarVisibilityStatus}`" id="affanOffcanvas" data-bs-scroll="true" tabindex="-1" aria-labelledby="affanOffcanvsLabel" :style="`visibility: ${sidebarVisibility}`" aria-modal="true" role="dialog">
      <button class="btn-close btn-close-white text-reset" @click="hideSideBar" type="button" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      <div class="offcanvas-body p-0">
        <!-- Side Nav Wrapper -->
        <div class="sidenav-wrapper">
          <!-- Sidenav Profile -->
          <div class="sidenav-profile bg-gradient">
            <div class="sidenav-style1"></div>
            <!-- User Thumbnail -->
            <div class="user-profile"><img :src="getAvatar" alt=""></div>
            <!-- User Info -->
            <div class="user-info">
              <h6 class="user-name mb-0">
                {{ userProfile().first_name || '' }} 
                {{ userProfile().last_name || '' }}
              </h6>
              <span>{{ auth().email }}</span>
            </div>
          </div>
          <!-- Sidenav Nav -->
          <ul class="sidenav-nav ps-0" style="display: flex; flex-direction: column">
            <li><router-link to="/dashboard" @click="selectNav('dashboard')"><i class="bi bi-house-door"></i>Home</router-link></li>
            <li><router-link to="/cards" @click="selectNav('cards')"><i class="bi bi-credit-card"></i>Card</router-link></li>
            <li><router-link to="/transaction" @click="selectNav('transaction')"><i class="bi bi-collection"></i>Transaction<span class="badge bg-success rounded-pill ms-2">0</span></router-link></li>
            <li><router-link to="/clusters" @click="selectNav('clusters')"><i class="bi bi-people"></i>Cluster</router-link></li>
            <!-- <li><router-link to="/my-plans" class="nav-url"><i class="bi bi-cart-check"></i>CoinSet<span class="dropdown-icon"><i class="bi bi-chevron-down"></i></span></router-link> -->
            <!-- <li>
              <a href="#" class="nav-url">
                <i class="bi bi-hand-index"></i> Module
                <span class="dropdown-icon"><i class="bi bi-chevron-down"></i></span>
              </a> 
              <ul>
                <li><a href="#" @click="handleNavChange('savings')">Savings</a></li>
                <li><a href="#" @click="handleNavChange('loan')">Loan</a></li>
                <li><a href="#" @click="handleNavChange('investment')">Invest</a></li>
              </ul>
            </li> -->
            <li><router-link to="/settings" @click="selectNav('settings')"><i class="bi bi-gear"></i>Settings</router-link></li>
            <li>
              <div class="night-mode-nav" @click="toggleNightMode">
                <i class="bi bi-moon"></i>Night Mode
                <div class="form-check form-switch">
                  <input class="form-check-input form-check-success" id="darkSwitch" type="checkbox">
                </div>
              </div>
            </li>
            <!-- <li><router-link to="/select-app" class="nav-url"><i class="bi bi-arrow-repeat"></i>Switch<span class="dropdown-icon"></span></router-link></li> -->
            <li><router-link to="#" @click="logoutUser"><i class="bi bi-box-arrow-right"></i>Logout</router-link></li>
          </ul>
          <!-- Social Info -->
          <div class="social-info-wrap"><a href="#"><i class="bi bi-facebook"></i></a><a href="#"><i class="bi bi-twitter"></i></a><a href="#"><i class="bi bi-linkedin"></i></a></div>
          <!-- Copyright Info -->
          <div class="copyright-info">
            <p>2021 © <a href="#">Redge</a></p>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="page-content-wrapper py-3">
      <div class="container"> -->
        <slot />
      <!-- </div>
    </div> -->

    <div class="footer-nav-area" id="footerNav">
      <div class="container px-0">
        <!-- =================================== -->
        <!-- Paste your Footer Content from here -->
        <!-- =================================== -->
        <!-- Footer Content -->
        <div class="footer-nav position-relative footer-style-two">
          <ul class="h-100 d-flex align-items-center justify-content-between ps-0">
            <li 
              :class="{
                'active': (activeFooterNav === 'dashboard' || !activeFooterNav) && activeAccount===ACCOUNT_TYPES.HOME
              }" 
              @click="selectNav('dashboard')"
            >
              <router-link class="stretched-link" to="/">
                <svg class="bi bi-house" width="20" height="20" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M2 13.5V7h1v6.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V7h1v6.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5zm11-11V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"></path>
                  <path fill-rule="evenodd" d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"></path>
                </svg><span>Home</span>
              </router-link>
            </li>
            <li :class="{'active': activeFooterNav === 'cards'}" @click="selectNav('cards')">
              <router-link class="stretched-link" to="/cards">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-credit-card" viewBox="0 0 16 16">
                  <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v1h14V4a1 1 0 0 0-1-1zm13 4H1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z"/>
                  <path d="M2 10a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z"/>
                </svg>
                <span>Card</span>
              </router-link>    
            </li>
            <!-- <li :class="{
                'active': (['', 'my-savings', 'dashboard'].includes(activeFooterNav) || !activeFooterNav) && activeAccount===ACCOUNT_TYPES.SAVINGS
              }" 
              v-if="activeAccount===ACCOUNT_TYPES.SAVINGS" 
              @click="selectNav('my-savings')"
            >
              <router-link class="stretched-link" to="/my-savings">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-wallet2" viewBox="0 0 16 16">
                  <path d="M12.136.326A1.5 1.5 0 0 1 14 1.78V3h.5A1.5 1.5 0 0 1 16 4.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 13.5v-9a1.5 1.5 0 0 1 1.432-1.499L12.136.326zM5.562 3H13V1.78a.5.5 0 0 0-.621-.484zM1.5 4a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/>
                </svg>
                <span>Savings</span>
              </router-link>    
            </li>
            <li 
              :class="{
                'active': (['', 'my-loans', 'dashboard'].includes(activeFooterNav) || !activeFooterNav) && activeAccount===ACCOUNT_TYPES.LOAN
              }"
              v-if="activeAccount===ACCOUNT_TYPES.LOAN" 
              @click="selectNav('my-loans')"
            >
              <router-link class="stretched-link" to="/my-loans">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-bank" viewBox="0 0 16 16">
                  <path d="m8 0 6.61 3h.89a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H15v7a.5.5 0 0 1 .485.38l.5 2a.498.498 0 0 1-.485.62H.5a.498.498 0 0 1-.485-.62l.5-2A.501.501 0 0 1 1 13V6H.5a.5.5 0 0 1-.5-.5v-2A.5.5 0 0 1 .5 3h.89zM3.777 3h8.447L8 1zM2 6v7h1V6zm2 0v7h2.5V6zm3.5 0v7h1V6zm2 0v7H12V6zM13 6v7h1V6zm2-1V4H1v1zm-.39 9H1.39l-.25 1h13.72l-.25-1Z"/>
                </svg>
                <span>Loans</span>
              </router-link>    
            </li>
            <li 
              :class="{
                'active': activeFooterNav === 'my-plans' || (!activeFooterNav && activeAccount===ACCOUNT_TYPES.INVESTMENT)
              }"
              v-if="activeAccount===ACCOUNT_TYPES.INVESTMENT" 
              @click="selectNav('my-plans')"
            >
              <router-link class="stretched-link" to="/my-plans">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-coin" viewBox="0 0 16 16">
                  <path d="M5.5 9.511c.076.954.83 1.697 2.182 1.785V12h.6v-.709c1.4-.098 2.218-.846 2.218-1.932 0-.987-.626-1.496-1.745-1.76l-.473-.112V5.57c.6.068.982.396 1.074.85h1.052c-.076-.919-.864-1.638-2.126-1.716V4h-.6v.719c-1.195.117-2.01.836-2.01 1.853 0 .9.606 1.472 1.613 1.707l.397.098v2.034c-.615-.093-1.022-.43-1.114-.9H5.5zm2.177-2.166c-.59-.137-.91-.416-.91-.836 0-.47.345-.822.915-.925v1.76h-.005zm.692 1.193c.717.166 1.048.435 1.048.91 0 .542-.412.914-1.135.982V8.518l.087.02z"/>
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                  <path d="M8 13.5a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11zm0 .5A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"/>
                </svg>
                <span>Investment</span>
              </router-link>    
            </li> -->
            <li :class='`${activeFooterNav === "transaction" ? "active": ""}`' @click="selectNav('transaction')">
              <router-link class="stretched-link" to="/transaction">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-cash-stack" viewBox="0 0 16 16">
                  <path d="M1 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1H1zm7 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"/>
                  <path d="M0 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V5zm3 0a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V7a2 2 0 0 1-2-2H3z"/>
                </svg>
                <span>Transaction</span>
              </router-link>
            </li>
            <li :class='`${activeFooterNav === "clusters" ? "active": ""}`' @click="selectNav('clusters')">
              <router-link class="stretched-link" to="/clusters">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-people" viewBox="0 0 16 16">
                  <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1zm-7.978-1L7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002-.014.002zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0M6.936 9.28a6 6 0 0 0-1.23-.247A7 7 0 0 0 5 9c-4 0-5 3-5 4q0 1 1 1h4.216A2.24 2.24 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816M4.92 10A5.5 5.5 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4"/>
                </svg>
                <span>Cluster</span>
              </router-link>    
            </li>
            <li :class='`${activeFooterNav === "settings" ? "active": ""}`' @click="selectNav('settings')">
              <router-link class="stretched-link" to="/settings">
                <svg class="bi bi-gear" width="20" height="20" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M8.837 1.626c-.246-.835-1.428-.835-1.674 0l-.094.319A1.873 1.873 0 0 1 4.377 3.06l-.292-.16c-.764-.415-1.6.42-1.184 1.185l.159.292a1.873 1.873 0 0 1-1.115 2.692l-.319.094c-.835.246-.835 1.428 0 1.674l.319.094a1.873 1.873 0 0 1 1.115 2.693l-.16.291c-.415.764.42 1.6 1.185 1.184l.292-.159a1.873 1.873 0 0 1 2.692 1.116l.094.318c.246.835 1.428.835 1.674 0l.094-.319a1.873 1.873 0 0 1 2.693-1.115l.291.16c.764.415 1.6-.42 1.184-1.185l-.159-.291a1.873 1.873 0 0 1 1.116-2.693l.318-.094c.835-.246.835-1.428 0-1.674l-.319-.094a1.873 1.873 0 0 1-1.115-2.692l.16-.292c.415-.764-.42-1.6-1.185-1.184l-.291.159A1.873 1.873 0 0 1 8.93 1.945l-.094-.319zm-2.633-.283c.527-1.79 3.065-1.79 3.592 0l.094.319a.873.873 0 0 0 1.255.52l.292-.16c1.64-.892 3.434.901 2.54 2.541l-.159.292a.873.873 0 0 0 .52 1.255l.319.094c1.79.527 1.79 3.065 0 3.592l-.319.094a.873.873 0 0 0-.52 1.255l.16.292c.893 1.64-.902 3.434-2.541 2.54l-.292-.159a.873.873 0 0 0-1.255.52l-.094.319c-.527 1.79-3.065 1.79-3.592 0l-.094-.319a.873.873 0 0 0-1.255-.52l-.292.16c-1.64.893-3.433-.902-2.54-2.541l.159-.292a.873.873 0 0 0-.52-1.255l-.319-.094c-1.79-.527-1.79-3.065 0-3.592l.319-.094a.873.873 0 0 0 .52-1.255l-.16-.292c-.892-1.64.902-3.433 2.541-2.54l.292.159a.873.873 0 0 0 1.255-.52l.094-.319z"></path>
                  <path fill-rule="evenodd" d="M8 5.754a2.246 2.246 0 1 0 0 4.492 2.246 2.246 0 0 0 0-4.492zM4.754 8a3.246 3.246 0 1 1 6.492 0 3.246 3.246 0 0 1-6.492 0z"></path>
                </svg><span>Settings</span>
              </router-link>    
            </li>
          </ul>
        </div>
      </div>
    </div>
  </base-template>
</template>

<script>
// @ is an alias to /src
import BaseTemplate from '@/components/templates/BaseTemplate.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { ACCOUNT_TYPES } from "../../store/states/account.state"

export default {
  name: 'PageTemplate',
  data() {
    const { logo } = this.appConfig() || {};
    return {
      logo: logo || require("../../assets/redge.png"),
      profile: {},
      defaultAvatar: "https://cdn-icons-png.flaticon.com/512/149/149071.png",
      sidebarVisibility: "hidden",
      sidebarVisibilityStatus: "",
      ACCOUNT_TYPES,
      appLogo: (document.querySelectorAll("html")[0]).getAttribute('data-theme'),
      timeoutInMS: 180000, // 3 minutes -> 3 * 60 * 1000
      timeoutId: null
    }
  },
  components: {
    BaseTemplate
  },
  methods: {
    selectNav(page) {
      if (page === 'dashboard') {
        this.switchAccount('home');
        this.getTransactions({})
      }
      this.setActiveFooterNav(page);
    },
    showSideBar() {
      this.sidebarVisibilityStatus = "show";
      this.sidebarVisibility = "visible"
    },
    hideSideBar() {
      this.sidebarVisibilityStatus = "";
      this.sidebarVisibility = "hidden"
    },
    ...mapActions([
      "logout",
      "myAccount",
      "switchAccount",
      "getTransactions",
    ]),
    ...mapMutations([
      "setActiveFooterNav"
    ]),
    ...mapGetters([
      "loaders",
      "activeFooterNav",
      "appConfig",
      "auth",
      "userProfile"
    ]),
    logoutUser() {
      this.logout().then( res => {
        console.log(res);
        const self = this;
        setTimeout( function(){
          self.$router.push('/login');
        }, 900);
      }).catch( err => {
        console.log(err)
      })
    },
    toggleNightMode() {
      const html = document.querySelectorAll("html")[0];
      const logo = document.getElementById("app-logo");

      if ( html.getAttribute('data-theme') === 'dark') {
        html.setAttribute('data-theme', 'light')
        this.appLogo = "light"//require('../../assets/redge.png');
      } else {
        html.setAttribute('data-theme', 'dark');
        this.appLogo = "dark"// require('../../assets/redge-light.png');
      }
    },
    handleInactive() {
      // Here you want to logout a user and/or ping your token
      this.logoutUser()
    },
    startTimer() { 
      // setTimeout returns an ID (can be used to start or clear a timer)
      this.timeoutId = setTimeout(this.handleInactive, this.timeoutInMS);
    },
    resetTimer() { 
      clearTimeout(this.timeoutId);
      this.startTimer();
    },
    setupTimers () {
      document.addEventListener("keypress", this.resetTimer, false);
      document.addEventListener("mousemove", this.resetTimer, false);
      document.addEventListener("mousedown", this.resetTimer, false);
      document.addEventListener("touchmove", this.resetTimer, false);
      
      this.startTimer();
    },
    handleNavChange(page) {
      this.switchAccount(page);
      this.$emit('pageChange', {page})
    }
  },
  computed: {
    getAvatar() {
      const img = this.userProfile() && this.userProfile().image ? this.userProfile().image : this.defaultAvatar;
      let knownTypes = {
        '/': 'data:image/jpg;base64,',
        'i': 'data:image/png;base64,',
        'R': 'data:image/gif;base64,',
        'U': 'data:image/webp;base64,',
      }
      
      return !knownTypes[img[0]] ? img : knownTypes[img[0]]+img;
    },
    ...mapGetters([
      "activeFooterNav",
      "activeAccount",
    ]),
  },
  mounted() {
    this.myAccount().catch( err => {
      const { message } = err
      if (message === "Unauthenticated.") {
        this.logout()
        const self = this;
        setTimeout( function(){
          self.$router.push('/login');
        }, 900);
      }
    });
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: rgba(var(--bs-success-rgb));
  text-decoration: none;
}
.social-info-wrap a, .copyright-info p a  {
  color: rgba(var(--bs-success-rgb));
}

.sidenav-profile {
  background-color: rgba(var(--bs-success-rgb));
}
.footer-nav ul li.active a, .footer-nav ul li a:hover, .footer-nav ul li a:focus {
    /* color: var(--jw-text-success); */
    text-decoration: none;
}
.footer-nav ul li a:hover span, .footer-nav ul li a:focus span {
    color: var(--jw-text-success);
    text-decoration: none;
}

.footer-nav ul li.active a span {
    display: none;
}
.navbar--toggler>svg>path, .navbar--toggler>svg>g>path{
  fill: rgba(var(--bs-success-rgb));
}

[data-theme=dark] body .navbar--toggler>svg>path, 
[data-theme=dark] body .navbar--toggler>svg>g>path {
  fill: rgba(255, 255, 255, 0.8);
}
.header-content.header-style-five .navbar--toggler {
    border: none;
    padding: 0px;
    border-radius: 4px;
}

.offcanvas-start {
    width: 320px;
}

.footer-nav.footer-style-two li.active a::before {
    background-color: var(--jw-text-success);
}

/* .footer-nav.footer-style-two li.active a {
    background-color: rgb(78 115 156 / 30%);
} */

[data-theme=dark] body .social-info-wrap a {
  color: rgba(255, 255, 255, 0.8);
}
</style>
